export const photoCaptureIsFileUploadStartedReducer = (state, isFileUploadStarted) => {
    return Object.assign(Object.assign({}, state), { isFileUploadStarted });
};
//# sourceMappingURL=photoCaptureIsFileUploadStartedReducer.js.map